import type { Design } from './viewdesigns.types';

export const designsMockData: Design[] = [
  {
    id: '1',
    uuid: 'design-uuid-001',
    name: 'Kitchen Cabinet Design',
    description: 'Modern kitchen cabinet with dual compartments',
    note: 'Client requested oak finish',
    status: 'active',
    customerId: 'customer-001',
    createdAt: '2026-02-15T10:30:00Z',
    updatedAt: '2026-02-20T14:22:00Z',
    content: {
      figures: [],
      others: []
    }
  },
  {
    id: '2',
    uuid: 'design-uuid-002',
    name: 'Bathroom Vanity Unit',
    description: 'Compact vanity with integrated storage',
    note: 'Waterproof coating required',
    status: 'active',
    customerId: 'customer-002',
    createdAt: '2026-02-10T09:15:00Z',
    updatedAt: '2026-02-18T16:45:00Z',
    content: {
      figures: [],
      others: []
    }
  },
  {
    id: '3',
    uuid: 'design-uuid-003',
    name: 'Office Desk Assembly',
    description: 'Adjustable height desk with cable management',
    note: 'Standing desk variant',
    status: 'active',
    customerId: 'customer-003',
    createdAt: '2026-02-05T11:20:00Z',
    updatedAt: '2026-02-22T10:10:00Z',
    content: {
      figures: [],
      others: []
    }
  },
  {
    id: '4',
    uuid: 'design-uuid-004',
    name: 'Bookshelf Design',
    description: 'Tall bookshelf with 6 shelves',
    note: '',
    status: 'active',
    customerId: null,
    createdAt: '2026-01-28T13:00:00Z',
    updatedAt: '2026-02-10T09:30:00Z',
    content: {
      figures: [],
      others: []
    }
  },
  {
    id: '5',
    uuid: 'design-uuid-005',
    name: 'TV Stand with Storage',
    description: 'Media console with drawer and open shelving',
    note: 'For 65" TV',
    status: 'active',
    customerId: 'customer-004',
    createdAt: '2026-01-20T15:45:00Z',
    updatedAt: '2026-02-01T12:20:00Z',
    content: {
      figures: [],
      others: []
    }
  }
];
